import { render, staticRenderFns } from "./CarouselEventOutcomes.vue?vue&type=template&id=7497ebc2&"
import script from "./CarouselEventOutcomes.vue?vue&type=script&lang=js&"
export * from "./CarouselEventOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketOutcomes: require('/var/web/bet777.es/components/market/outcomes.vue').default})
